import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import Utils from "src/utils/Utils";

class Check2FATask extends AbstractRequestTask {
    constructor(params) {
        super();
        this.ownParams = params;
    }

    getEncType() {
        return 'application/json';
    }

    getQueryStringParams() {
        const params = super.getParams();
        delete params.authpn;
        delete params.authpt;
        delete params.user_token;
        delete params.device_category;
        delete params.device_manufacturer;
        delete params.device_model;
        delete params.device_type;
        delete params.device_id;
        delete params.device_name;
        delete params.device_so;
        delete params.region;
        delete params.api_version;
        delete params.format;
        delete params.HKS;
        delete params.user_id;
        const qsParams = Object.assign({}, params);
        return Utils.buildQueryParams(qsParams);
    }

    getParams() {
        const transactionId = this.ownParams.transactionId;
        return {
            id_transaccion: transactionId
        };
    }

    getUrl() {
        const protocol = 'https';
        const server = Launcher.get("akamai_mfwk");
        return `${protocol}://${server}${this.ownParams.check2faURL}?${this.getQueryStringParams()}`;
    }
}

export default Check2FATask;



// WEBPACK FOOTER //
// ./src/requests/tasks/payway/Check2FATask.js